import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeFirst';
const args = {};

export class ModeFirst extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
